import store from "./store";
import cache from "./cache_ls";
import utility from "./utility";
import media_utility from "./media_utility"; 

export default class socket_listener {
  socket = null;
  userData = null;
  constructor() {
    this.socket = store.getters.getSocket;
    this.userData = store.getters.userData;
    
    //Socket on for maintenance
    this.maintenance_state_change_response();
    
    //Socket on for chatmsg_add_response
    this.chatmsg_add_response();

    //Socket on for chatmsg_delete_response
    this.chatmsg_delete_response();

    //Socket on for chatgrp_edit_response
    this.chatgrp_edit_response();

    //Socket on for group_action_response
    this.group_action_response();

    //Socket on for group_delete_response
    this.group_delete_response();

    //Socket on for group_delete_response
    this.user_edit_response();

    //Socket on for group_add_response
    this.group_add_response();

    //Socket on for card_locked_response
    this.card_locked_response();

    //Socket on for card_moved_response
    this.card_moved_response();

    //Socket on for topic_moved_response
    this.topic_moved_response();

    //Socket on for account_role_assign_response
    this.account_role_assign_response();

    //Socket on for calendar_event_reminder_response
    this.calendar_event_reminder_response();

    //Socket on for calendar_event_add_response
    this.calendar_event_add_response();

    //Socket on for calendar_event_edit_response
    this.calendar_event_edit_response();
  }

  /**
  * maintenance_state_change_response listener from socket
  */
  maintenance_state_change_response() {
    /*Listen on Socket for maintenance_state*/
    this.socket.on('maintenance_state_change_response', (state) => {
      if (process.env.VUE_APP_DEBUG == "true") {console.log("Listen Received from Socket Message ==> maintenance_state=", state, "env state=",process.env.VUE_APP_MAINTENANCE_ON);}

      if(state == "true"){
        window.location.replace(process.env.VUE_APP_CONTENT_URL+"/m");
      } 
    });
  }

  /**
  * chatmsg_delete_response listener from socket
  */
  chatmsg_delete_response() {
    /*Listen on Socket for chatmsg_delete_response*/
    this.socket.on('chatmsg_delete_response', (data) => {
      let message = {};
      message[data.this_message_id] = data;

      if (process.env.VUE_APP_DEBUG == "true") {console.log("Listen Received from Socket Message ==> ", JSON.stringify(message));}
      this.delete_message_localforage(message);
      store.commit('setListenerChatmsgDeleteResponse', message);
    });
  }

  /**
  * chatmsg_add_response listener from socket
  */
   chatmsg_add_response() {
    /*Listen on Socket for chatmsg_add_response*/
    this.socket.on('chatmsg_add_response', async (data) => {
      let message = {};
      message[data.this_message_id] = data;
      if (process.env.VUE_APP_DEBUG == "true") {console.log("Listen Received from Socket Message ==> ", JSON.stringify(message));}

      //for media file only image auto download message_content_type == 1 is media message
      if(data.message_content_type && data.message_content_type == 1 && data.message_content_data){
        if(data.message_content_data.file_type == 'image'){
          media_utility.fileAutoDownload(data.message_content_data);
        }
      }
            
      this.add_message_localforage(message);
      store.commit('setListenerChatmsgAddResponse', message);
    });
  }
  /**
   * chatgrp_edit_response listener from socket
   */
  chatgrp_edit_response() {
    /*Listen on Socket for chatgrp_edit_response*/
    this.socket.on('chatgrp_edit_response', async (data) => {
      if (process.env.VUE_APP_DEBUG == "true") {console.log("chatgrp_edit_response: ", JSON.stringify(data));}
      await this.listen_for_edit_group_details(data);
      store.commit('setListenerChatgrpEditResponse', data);
    });
  }

  /**
   * group_action_response listener from socket
   */
  group_action_response() {
    this.userData = store.getters.userData;
    /*Listen on Socket for group_action_response*/
    this.socket.on('group_action_response', async (data) => {
      if (process.env.VUE_APP_DEBUG == "true") {console.log("group_action_response: ", JSON.stringify(data));}
      
      // participant removed
      if (data.action == "2") {
        // updating participants
        let grpParticipants = await store.getters.getGroupParticipants
        let newParticipants = grpParticipants[data.group_id].filter(p => p.participant_id != data.participant_id)
        grpParticipants[data.group_id] = newParticipants
        store.commit("setGroupParticipants", grpParticipants)
      }

      let chatgrpList = await store.getters.getChatgrpList;
      if (chatgrpList != null && chatgrpList.length > 0) {
        let grp_index = chatgrpList.findIndex((group) => { return group.group_id === data.group_id });
        if (data.role != null && data.role != undefined) {
          chatgrpList[grp_index].role = data.role;
        }

        if (data.action == 2) { //if participant remove from group then update group list
          if (data.participant_id === this.userData.user_id) {
            chatgrpList = chatgrpList.filter((group) => { return group.group_id !== data.group_id });

            if (process.env.VUE_APP_DEBUG == "true") {console.log("unsubscribe_group_id_list", this.userData.user_id, data.group_id);}
            this.socket.emit('unsubscribe_group_id_list', this.userData.user_id, data.group_id);
          }

          //Get unread message group list
          let get_unread_chat_grp = await  store.getters.getUnreadChatgrp;
          let unread_chatgrp = (get_unread_chat_grp) ? get_unread_chat_grp : {};
          if (Object.keys(unread_chatgrp).length > 0) {
            delete unread_chatgrp[data.group_id];
          }

          await store.commit('setUnreadChatgrp', unread_chatgrp);
        }

        await store.commit('setChatgrpList', chatgrpList);
      }
      store.commit("setListenerGroupActionResponse", data);
    });
  }

  /**
   * group_delete_response listener from socket
   */
  group_delete_response() {
    /*Listen on Socket for group_delete_response*/
    this.socket.on('group_delete_response', async (data) => {
      if (process.env.VUE_APP_DEBUG == "true") {console.log("group_delete_response: ", JSON.stringify(data));}
      let chatgrpList = await store.getters.getChatgrpList;
      let deleted_group = data.group;
      chatgrpList = chatgrpList.filter((group) => { return group.group_id !== deleted_group.group_id });
      await store.commit('setChatgrpList', chatgrpList);

      //Get unread message group list
      let get_unread_chat_grp = await  store.getters.getUnreadChatgrp;
      let unread_chatgrp = (get_unread_chat_grp) ? get_unread_chat_grp : {};
      if (Object.keys(unread_chatgrp).length > 0) {
        delete unread_chatgrp[deleted_group.group_id];
      }
      await store.commit('setUnreadChatgrp', unread_chatgrp);

      store.commit("setListenerGroupDeleteResponse", data);
    });
  }

  /**
  * group_add_response listener from socket
  * Currently this listener is used only for one to one chat group add It can be used other purpose if needed
  */
  group_add_response() {
    /*Listen on Socket for group_add_response*/
    this.socket.on('group_add_response', async (data) => {
      if (process.env.VUE_APP_DEBUG == "true") {console.log("group_add_response: ", JSON.stringify(data));}
      let chatgrpList = await store.getters.getChatgrpList;
      let new_grp_data = data.groupInfo;

      //Check for one to one group
      if (new_grp_data.type == 0) {
        if (new_grp_data.created_By !== this.userData.user_id) {
          new_grp_data['last_msg'] = data.message['text_msg'];
          new_grp_data['last_msg_sender'] = data.message['sender_name'];

          if (data.message['message_time']) {
            new_grp_data['last_msg_time'] = utility.get_message_datetime(data.message['message_time'], 'DD/MM/YYYY');
            new_grp_data['last_msg_ts'] = data.message['message_time'];
          }
          else {
            new_grp_data['last_msg_time'] = "--:--";
          }

          chatgrpList.unshift(new_grp_data);
          await store.commit('setChatgrpList', chatgrpList);

          if (!window.webkit && !window.androidBridge) {
            //Not needed for mobile
            store.commit('setListenerGroupAddResponse', data);
          }
        }
      }
    });
  }

  /**
   * user_edit_response listener from socket
   */
  user_edit_response() {
    /*Listen on Socket for user_edit_response*/
    this.socket.on('user_edit_response', async (data) => {
      this.userData = store.getters.userData;

      //process for user image base64 
      var user_contact_list = await store.getters.getUserContactList;
      if(user_contact_list == null){
        user_contact_list = {};
      }

      if(process.env.VUE_APP_DEBUG == "true") {
        console.log('user_icon:-socket listener user_edit_response', user_contact_list);
      }

      if(Object.keys(user_contact_list).length > 0){
        var user_contact = (user_contact_list[data.user_id]) ? user_contact_list[data.user_id] : {
          user_image_base64: null,
          image_checksum: null
        };
        
        if(user_contact.user_image_base64 == null 
        || (user_contact.image_checksum != data.image_checksum))
        {
          if(data.image){
            var base64_thumbnail = await media_utility.getBase64ImageThumbnail(data.image);
            if(process.env.VUE_APP_DEBUG == "true") {
              console.log('user_icon:-socket listener user_edit_response base64_thumbnail', base64_thumbnail);
            }

            if(base64_thumbnail){
              user_contact_list[data.user_id].user_image_base64 = base64_thumbnail;
              user_contact_list[data.user_id].image_checksum = data.image_checksum;
              await store.commit('setUserContactList', user_contact_list);
              if(process.env.VUE_APP_DEBUG == "true") {
                console.log('user_icon:-socket listener user_edit_response setUserContactList user_contact_list', user_contact_list);
              }
            }
          }
        }
      }
      //end of process for user image base64 

      if (data.user_id == this.userData.user_id) {
        if (data.image == null && data.image == undefined) {
          data.image = this.userData.image;
        }
        data.account_info = this.userData.account_info;
        store.commit("setUserProfile", data);
      }

      store.commit("setListenerUserEditResponse", data);
    });
  }

  /**
   * add_message_localforage
   * Helper method:- Watch on the latest message, to be stored in chat message localforage
   */
  async add_message_localforage(msg) {
    let chatgrpList = await store.getters.getChatgrpList;
    let userData = store.getters.userData;

    let msgIndex = Object.keys(msg);
    //Find the index of the group list in which the message has to be rendered
    if (chatgrpList != null && chatgrpList.length > 0) {
      let index = chatgrpList.findIndex(x => x && x.group_id && x.group_id == msg[msgIndex]['group_id']);

      if (chatgrpList[index] != undefined) {
        let cache_chatmsg_list = [];
        let chatmsg_list = await cache.get_chatmsg_list_lf(msg[msgIndex]['group_id']);
        if(chatmsg_list){
          cache_chatmsg_list = chatmsg_list;
        }

        //check message is alredy in cache_chatmsg_list or not if not then pushed in cache_chatmsg_list
        let isPresent = cache_chatmsg_list.some((message) => { return message.this_message_id == msg[msgIndex].this_message_id });
        if (!isPresent) {
          /* remove older message with 0 index when cache_chatmsg_list is greater then 
          * pagination per_page and pushed new message at last
          */
          if (cache_chatmsg_list.length >= process.env.VUE_APP_APP_MESSAGE_PER_PAGE) {
            cache_chatmsg_list.splice(cache_chatmsg_list.length, 1);
          }

          cache_chatmsg_list.unshift(msg[msgIndex]);
          await cache.set_chatmsg_list_lf(msg[msgIndex]['group_id'], cache_chatmsg_list);
        }

        {
          //Get unread message group list. Needed only for Mobile
          let get_unread_chat_grp = await  store.getters.getUnreadChatgrp;
          let unread_chatgrp = (get_unread_chat_grp) ? get_unread_chat_grp : {};

          //Only add to unread if sent by another user
          if(msg[msgIndex]['sender_id'] != userData.user_id) {
            //push unread message
            unread_chatgrp[msg[msgIndex]['group_id']] = true;
            await store.commit('setUnreadChatgrp', unread_chatgrp);
          }
        }
      }
    }
  }

  /**
  * delete_message_localforage
  * Helper method:- Watch on the delete message, to be stored in chat message localforage
  * and insert last message after delete from fetch localsforage
  */
  async delete_message_localforage(msg) {
    let chatgrpList = await store.getters.getChatgrpList;

    let msgIndex = Object.keys(msg);
    //Find the index of the group list in which the message has to be rendered
    let index = chatgrpList.findIndex(x => x && x.group_id && x.group_id === msg[msgIndex]['group_id']);

    if (chatgrpList[index] != undefined) {
      let cache_chatmsg_list = [];
      let chatmsg_list = await cache.get_chatmsg_list_lf(msg[msgIndex]['group_id']);
      if (chatmsg_list && chatmsg_list != null) {
        cache_chatmsg_list = chatmsg_list;
      }

      //check message is alredy in cache_chatmsg_list or not if not then pushed in cache_chatmsg_list
      let message_index = cache_chatmsg_list.findIndex((message) => { return message.this_message_id === msg[msgIndex].this_message_id });
      if (message_index > '-1') { // -1 is for is message not found in cache_chatmsg_list

        //remove message with delete message index 
        cache_chatmsg_list.splice(message_index, 1);
        await cache.set_chatmsg_list_lf(msg[msgIndex]['group_id'], cache_chatmsg_list);

        //Get last message after deleted message for chatgrp list
        let last_message = cache_chatmsg_list[cache_chatmsg_list.length - 1];
        chatgrpList[index].last_msg = last_message.text_msg ? last_message.text_msg : "";
        chatgrpList[index].last_msg_sender = last_message.sender_name;
        chatgrpList[index].last_msg_time = utility.get_message_datetime(last_message.message_time, 'DD/MM/YYYY');
        chatgrpList[index].last_msg_ts = last_message.message_time;
        await store.commit('setChatgrpList', chatgrpList);
      }
    }
  }

  /**
   * listen_for_edit_group_details.
   * Helper method:- Set group list after change in group only for set cache group list
   */
  async listen_for_edit_group_details(group) {
    let chatgrpList = await store.getters.getChatgrpList;

    let chatgrpIconList = await store.getters.getChatgrpIconList;
    if(chatgrpIconList == null){
      chatgrpIconList = {};
    }

    let group_key = chatgrpList.findIndex(g => {
      return g.group_id === group.groupInfo.group_id;
    });

    if (group_key !== false && group_key != '-1') {

      /*  Get that groups which have not any checksum or if have that is new checksum
      *   After logout and login again its have all groups
      */
     if(chatgrpIconList[group.groupInfo.group_id] == undefined 
     || chatgrpIconList[group.groupInfo.group_id].group_icon_checksum != group.groupInfo.group_icon_checksum)
     {
       var group_icon_base64 = await media_utility.getBase64ImageThumbnail(group.groupInfo.group_icon);
       chatgrpIconList[group.groupInfo.group_id].group_icon_checksum = group.groupInfo.group_icon_checksum;
       chatgrpIconList[group.groupInfo.group_id].group_icon_base64 = group_icon_base64;
     }

      //keep last message, last message sender and time before override grpdetais and localstorage
      group.groupInfo.last_msg = chatgrpList[group_key]['last_msg'] ? chatgrpList[group_key]['last_msg'] : "";
      group.groupInfo.last_msg_sender = chatgrpList[group_key]['last_msg_sender'];
      group.groupInfo.last_msg_time = chatgrpList[group_key]['last_msg_time'];
      group.groupInfo.last_msg_ts = chatgrpList[group_key]['last_msg_ts'];
      chatgrpList[group_key] = group.groupInfo;
      //save groups to ls
      await store.commit('setChatgrpList', chatgrpList);
    }
  }

 /*
  * card_locked_response: Set card in locked cards list
  *
  */
  async card_locked_response() {
    this.socket.on('card_locked_response', async (data) => {

      if (process.env.VUE_APP_DEBUG == "true") {console.log("card_locked_response: Listen Received from Socket Cards ==> ", JSON.stringify(data));}

      store.commit('setListenerCardLockedResponse', data);
    });
  }

 /*
  * card_moved_response: Move card
  *
  */
  async card_moved_response() {
    this.socket.on('card_moved_response', async (data) => {

      if (process.env.VUE_APP_DEBUG == "true") {console.log("card_moved_response: Listen Received from Socket Cards ==> ", JSON.stringify(data));}

      if(data) {
        store.commit('setListenerCardMovedResponse', data);
      }
    });
  }

 /*
  * topic_moved_response: Move topic
  *
  */
  async topic_moved_response() {
    this.socket.on('topic_moved_response', async (data) => {

      if (process.env.VUE_APP_DEBUG == "true") {console.log("topic_moved_response: Listen Received from Socket Cards ==> ", JSON.stringify(data));}

      if(data) {
        store.commit('setListenerTopicMovedResponse', data);
      }
    });
  }

 /*
  * account_role_assign_response
  *
  */
  async account_role_assign_response() {
    this.socket.on('account_role_assign_response', async (data) => {

      if (process.env.VUE_APP_DEBUG == "true") {console.log("account_role_assign_response ==> ", JSON.stringify(data));}

      this.userData = store.getters.userData;

      if(data && data.user_id == this.userData.user_id) {
        this.userData.account_info = data.data;
        store.commit('setUserProfile', this.userData);
      }
    });
  }

  /**
   * calendar_event_reminder_response listener from socket
   */
  async calendar_event_reminder_response() {
    /*Listen on Socket for calendar_event_reminder_response*/
    this.socket.on('calendar_event_reminder_response', (data) => {
      if (process.env.VUE_APP_DEBUG == "true") {console.log("calendar_event_reminder_response", "Listen Received from Socket Message ==> ", JSON.stringify(data));}

      this.userData = store.getters.userData;
      
      //Ensure that data.text is not in HTML Format. It should ALWAYS BE TEXT FORMAT
      if(data.user_id == this.userData.user_id){
        let display_text = data.subject;

        if(data.schedule_utc_time){
          display_text += "\n\nThis event will begin on: \n"+new Date(data.schedule_utc_time);
        }

        if(data.desc){
          display_text += "\n\n"+data.desc;
        }

        alert(display_text);
      }        
    });
  }

  /*
  * calendar_event_add_response
  * */
  async calendar_event_add_response() {
    this.socket.on('calendar_event_add_response', async (data) => {

      if (process.env.VUE_APP_DEBUG == "true") {console.log("calendar_event_add_response: Listen Received from Socket Cards ==> ", JSON.stringify(data));}

      if(data) {
        this.userData = store.getters.userData;
        if(data['attendees'] && data['attendees'].length > 0) {
          if(data['attendees'].indexOf(this.userData.user_id) > -1) {
            store.commit('setListenerCalendarEventAddResponse', data);
          }
        }
      }
    });
  }

  /*
  * calendar_event_edit_response
  * */
  async calendar_event_edit_response() {
    this.socket.on('calendar_event_edit_response', async (data) => {

      if (process.env.VUE_APP_DEBUG == "true") {console.log("calendar_event_edit_response: Listen Received from Socket Cards ==> ", JSON.stringify(data));}

      if(data) {
        this.userData = store.getters.userData;
        if(data['attendees'] && data['attendees'].length > 0) {
          if(data['attendees'].indexOf(this.userData.user_id) > -1) {
            store.commit('setListenerCalendarEventAddResponse', data);
          }
        }
      }
    });
  }

}
